import axios from 'axios';

const getFinancialInstitution = (tokenId: string): Promise<any> =>  {
    const getFiConfigUrl: string = '/api/kcas/ficonfig/fi/' + tokenId + '/kasasa-fiid';
    return axios.get(getFiConfigUrl);
}


export {
    getFinancialInstitution,
}